import { Box, IconButton, Table, TableBody, TableHead, TableRow, Typography } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import {
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  CustomCheckbox,
  NoDataSkeleton,
  StatusChip,
} from '../../../common';

const formatPeriodLabel = (month, year) => {
  if (!month || !year) {
    return 'Periodo N/D';
  }

  const normalizedMonth = String(month).padStart(2, '0');
  return `Periodo ${normalizedMonth}/${year}`;
};

const formatFeeLabel = (feeNumber1, feeNumber2) => {
  const first = Number(feeNumber1);
  const second = feeNumber2 !== undefined && feeNumber2 !== null ? Number(feeNumber2) : null;

  if (Number.isNaN(first)) {
    return null;
  }

  if (first === 0) {
    return 'Adecuación';
  }

  if (!second || second === 0 || second === first) {
    return `Cuota ${first}`;
  }

  return `Cuotas ${first}-${second}`;
};

const buildCouponLabel = (coupon) => {
  const period = formatPeriodLabel(coupon.month, coupon.year);
  const fee = formatFeeLabel(coupon.fee_number1, coupon.fee_number2);
  return fee ? `${period} • ${fee}` : period;
};

const CouponsMailsDataTable = ({
  data,
  isLoading,
  includeAllSubscribers,
  totalCount,
  selectedItems,
  onSendEmail,
  onSelectItem,
  LoadingComponent,
}) => {
  if (includeAllSubscribers) {
    return (
      <GeneralTableBox>
        <Box
          sx={{
            m: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '200px',
          }}
        >
          <Typography variant="h6" align="center" gutterBottom>
            Todos los suscriptores han sido seleccionados para enviar su respectivo mail.
          </Typography>
          <Typography variant="h6" align="center">
            Total de suscriptores seleccionados: {totalCount}
          </Typography>
        </Box>
      </GeneralTableBox>
    );
  }

  return (
    <GeneralTableBox>
      <Table
        aria-label="coupons mails table"
        sx={{
          maxHeight: '60em',
          overflow: 'auto',
        }}
      >
        <TableHead>
          <TableRow>
            <HeadTableCell wmd="10%" wxs="15%">
              N° Contrato
            </HeadTableCell>
            <HeadTableCell wmd="20%" wxs="25%">
              Suscriptores
            </HeadTableCell>
            <HeadTableCell wmd="50%" wxs="40%">
              Cupones
            </HeadTableCell>
            <HeadTableCell wmd="10%" wxs="10%">
              Enviar
            </HeadTableCell>
            <HeadTableCell wmd="10%" wxs="10%">
              Seleccionar
            </HeadTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <LoadingComponent />
          ) : data && data.length > 0 ? (
            data.map((subscriber, key) => (
              <TableRow
                key={key}
                sx={{
                  '&:hover': {
                    backgroundColor: '#f5f5f5',
                  },
                }}
              >
                <RowTableCell fontxs="12px" fontmd="14px">
                  {subscriber.contract_number}
                </RowTableCell>

                <RowTableCell fontxs="12px" fontmd="14px">
                  {`${subscriber.first_name} ${subscriber.last_name}`}
                </RowTableCell>

                <RowTableCell>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 0.75,
                      fontSize: { xs: '12px', md: '14px' },
                    }}
                  >
                    {subscriber.coupons.map((coupon, index) => (
                      <StatusChip
                        key={`${coupon.uuid || index}`}
                        variant="filled"
                        status="neutral"
                        label={buildCouponLabel(coupon)}
                        size="small"
                      />
                    ))}
                  </Box>
                </RowTableCell>

                <RowTableCell>
                  <IconButton
                    size="small"
                    onClick={() => onSendEmail(subscriber)}
                    sx={{
                      '&:hover': {
                        transform: 'scale(1.1)',
                        backgroundColor: 'rgba(94, 137, 79, 0.08)',
                      },
                    }}
                  >
                    <EmailIcon sx={{ color: '#5e894f' }} />
                  </IconButton>
                </RowTableCell>

                <RowTableCell>
                  <CustomCheckbox
                    checked={selectedItems.some(
                      (item) => item.subscriber_uuid === subscriber.subscriber_uuid
                    )}
                    onChange={() => onSelectItem(subscriber)}
                    label=""
                    sx={{ padding: '4px' }}
                  />
                </RowTableCell>
              </TableRow>
            ))
          ) : (
            <NoDataSkeleton colSpan={5} message="No se encontraron cupones para enviar por email" />
          )}
        </TableBody>
      </Table>
    </GeneralTableBox>
  );
};

export default CouponsMailsDataTable;
